<template>
  <div class="columns is-gapless">
    <form @submit.prevent.stop="submit" @change="submit" class="column is-4 has-bg-white">
      <div class="column is-border-bottom" style="min-height: 85px">
        <h2 class="title is-size-3 has-text-weight-light">
          <span> {{ lotCount }} lots disponibles dans {{ localisablePrograms.length }} programmes</span>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <span v-show="smallLoading" class="is-size-7"><br><i class="fal fa-spin fa-spinner is-margin-xsmall"></i> chargement en cours ...</span>
          </transition>
        </h2>
      </div>
      <div class="columns is-border-bottom">
        <div class="column">
          <h2 class="has-text-weight-light is-size-6">
            <router-link :to="programListUrl" class="has-text-primary"><i class="fa-lg fal fa-building"></i>
              Accéder aux Programmes
            </router-link>
          </h2>
        </div>
        <div class="column is-paddingless-left">
          <h2 class="has-text-weight-light is-size-6">
            <router-link :to="lotListUrl" class="has-text-primary"><i class="fa-lg fal fa-key"></i> Accéder aux
              Lots
            </router-link>
          </h2>
        </div>
      </div>
      <!-- <div class="columns">
        <div class="column">
          <p class="label">Adresse :</p>
          <GmapAutocomplete @place_changed="getAddressData" class="input"></GmapAutocomplete>
        </div>
      </div> -->
      <div class="columns is-border-bottom">
        <div class="column is-two-thirds">
          <label class="label">{{ defaultStateLabel.label }}</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.state">
                <option :value="null">Sélectionner {{defaultStateLabel.label}}</option>
                <option v-for='s in states' :value="s.code" :key="s.code">{{s.name}} ({{s.code}})</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-border-bottom">
        <div class="column is-two-thirds">
          <label class="label">Date de livraison</label>
          <div class="control">
            <div class="select">
              <select v-model="filters.date_livraison">
                <option :value="null">Sélectionner une date de livraison</option>
                <option v-for='trim in trimestrialsChoices' :value="trim[0]">{{trim[1]}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-border-bottom">
          <p class="label">Nature du bien</p>
          <div class="columns is-gapless is-multiline">
            <div class="column is-margin-top-small is-half" v-for="n in naturesList">
              <div class="field">
                <input class="is-checkradio" :id="n.value" type="checkbox" :name="n.value" :value="n.value"
                       v-model="filters.nature">
                <label :for="n.value">{{ n.label }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-padding-left is-padding-right is-border-bottom">
        <div class="column is-paddingless-left">
          <div class="field">
            <range-chooser formatter="{value} m2"
                           @change="filters.surface__gte = $event"
                           :max="500" :label="'m2 Supérieur à'"
                           :step="25" :model="filters.surface__gte"></range-chooser>
          </div>
        </div>
        <div class="column is-paddingless-left">
          <div class="field">
            <range-chooser formatter="{value} m2"
                           @change="filters.surface__lte = $event"
                           :max="500" :label="'m2 Inférieur à'"
                           :step="25" :model="filters.surface__lte"></range-chooser>
          </div>
        </div>
      </div>
      <div class="columns is-padding-left is-padding-right is-border-bottom">
        <div class="column is-paddingless-left">
          <div class="field">
            <range-chooser :formatter="`{value} ${currency}`"
                           @change="filters.sale_price__gte = $event"
                           :max="750000" :label="'Prix Supérieur à'"
                           :step="25000" :model="filters.sale_price__gte"></range-chooser>
          </div>
        </div>
        <div class="column is-paddingless-left">
          <div class="field">
            <range-chooser :formatter="`{value} ${currency}`"
                           @change="filters.sale_price__lte = $event"
                           :max="750000" :label="'Prix Inférieur à'"
                           :step="25000" :model="filters.sale_price__lte"></range-chooser>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-border-bottom">
          <p class="label">Nombre de {{lotDefaultTypeLabel}}</p>
          <div class="columns is-gapless is-multiline">
            <div class="column is-margin-top-small is-half" v-for="t in typesFilterList">
              <div class="field">
                <input class="is-checkradio" :id="t.value" type="checkbox" :name="t.value" :value="t.value"
                       v-model="filters.lot_type">
                <label :for="t.value">{{ t.label }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="column">
      <div class="map-fixed">
        <div class="loader-overlay" v-if="!smallLoading && !programs.length">
          <div class="columns is-desktop is-vcentered is-min-height-full">
            <div class="column has-text-centered">
              <h1 class="title is-2 is-paddingless-bottom is-margin-bottom-small has-text-white">Aucun résultat</h1>
              <p class="is-paddingless-top is-margin-top-small has-text-white">Changez vos critères de filtrage</p>
            </div>
          </div>
          <!-- <spinner-round v-else :isLoading="loading"></spinner-round> -->
        </div>
        <gmap-map ref="gmap" :center="center" :zoom="zoom" :options="mapOptions" style="height: 100%">
          <gmap-cluster v-if="!loading" @click="zoomOnCluster">
            <gmap-marker v-for="p in localisablePrograms" :key="p.pk"
                         :position="{lat: p.location.latitude, lng: p.location.longitude}" :clickable="true"
                         @click="openWindowInfo(p)">
            </gmap-marker>
            <gmap-info-window @closeclick="windowInfoOpened = false; program = null; programLotCount = null"
                              :opened="windowInfoOpened"
                              :position="windowInfoPos" v-if="windowInfoOpened">
              <div class="card map-info" v-if="program">
                <header class="card-header is-border-bottom">
                  <p class="card-header-title is-size-3">{{ program.name }}</p>
                </header>
                <div class="card-content" v-if="program.pictures && program.pictures.length">
                  <div class="content">
                    <img width="100%" :src="program.pictures[0].path" :alt="program.name + ' Image'">
                  </div>
                </div>
                <div class="card-content is-border-top">
                  <div class="content has-text-grey is-uppercase is-size-6">
                    <router-link v-if="programLotCount" :to="currentProgramUrl">
                      <span class="dot has-bg-disponible is-inline-block is-vcentered is-margin-right-small"></span>
                      {{programLotCount}} lots encore disponibles
                    </router-link>
                  </div>
                </div>
                <footer class="card-footer is-light">
                  <div class="column">
                    <router-link :to="{name: 'ProgramVue', params: {id: program.program}}"
                                 class="button is-primary is-full">Voir la fiche
                    </router-link>
                  </div>
                </footer>
              </div>
              <!--<div class="card" style="max-width: 350px;" v-if="program">
                <header class="card-header">
                  <h2 class="card-header-title">{{ program.name }}</h2>
                </header>
                <div class="card-image" v-if="program.pictures && program.pictures.length">
                  <figure class="image is-16-9">
                    <img :src="program.pictures[0].s3_path" :alt="program.name + ' Image'">
                  </figure>
                </div>
                <div class="card-content">
                  <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}"
                               class="button is-primary is-fullwidth">Voir le programme
                  </router-link>
                </div>
              </div> -->
            </gmap-info-window>
          </gmap-cluster>
        </gmap-map>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .columns.is-vcentered {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
</style>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { DefaultValues, Filter } from '../../mixins'

  export default {
    name: 'DashboardSeller',
    mixins: [DefaultValues, Filter],
    data () {
      return {
        service: this.$api.eventService,
        lotCount: 0,
        filters: {
          nature: [],
          lot_type: []
        },
        initFilters: {
          nature: [],
          lot_type: []
        },
        zoom: 6,
        center: {lat: 46.1445466, lng: 2.4343558},
        windowInfoOpened: false,
        windowInfoPos: {lat: 0, lng: 0},
        programs: [],
        program: null,
        programLotCount: null,
        loading: false,
        smallLoading: false
      }
    },
    computed: {
      ...mapState([
        'states',
        'events',
        'options',
        'currentUser'
      ]),
      ...mapGetters(['currentUserName', 'isLog', 'newEvents', 'currentUserPicture']),
      currency () {
        return this.$currency
      },
      lotListUrl () {
        let query = {
          nature: this.filters.nature,
          lot_type: this.filters.lot_type,
          date_livraison: this.filters.date_livraison,
          surface__gte: this.filters.surface__gte,
          surface__lte: this.filters.surface__lte,
          sale_price__gte: this.filters.sale_price__gte,
          sale_price__lte: this.filters.sale_price__lte,
          state: this.filters.state
        }
        return {name: 'StockLots', query}
      },
      programListUrl () {
        let query = {
          date_livraison: this.filters.date_livraison,
          state: this.filters.state
        }
        return {name: 'StockPrograms', query}
      },
      currentProgramUrl () {
        let url = this.lotListUrl
        url.query.program = this.program.program
        return url
      },
      localisablePrograms () {
        return this.programs.filter(p => {
          if (p.location && p.location.longitude && p.location.latitude && p.address.country.toLowerCase() === 'france') {
            return true
          }
          return false
        })
      },
      availableLots () {
        let c = 0
        this.localisablePrograms.forEach(p => {
          c += p.lot_counts.available
          c += p.lot_counts.optioned
        })
        return c
      },
      mapOptions () {
        return {
          streetViewControl: false,
          styles: this.mapStyle
        }
      }
    },
    methods: {
      zoomOnCluster (cluster) {
        let bounds = cluster.bounds_
        this.$refs.gmap.fitBounds(bounds)
      },
      changeZoom (zoom) {
        console.log('change zoom > ', zoom)
        this.zoom = zoom
      },
      updateCenter ({lat, lng}, zoom = 7) {
        this.changeZoom(zoom)
        this.center = {
          lat,
          lng
        }
      },
      zoomOnFrance () {
        let bounds = new window.google.maps.LatLngBounds()

        bounds.extend({
          lat: 49.33638425256043,
          lng: 4.698916625976608
        })

        bounds.extend({
          lat: 42.243155255468025,
          lng: 9.31414
        })

        this.$refs.gmap.fitBounds(bounds)
      },
      fitBounds () {
        let bounds = new window.google.maps.LatLngBounds()
        this.localisablePrograms.forEach(x => {
          bounds.extend({
            lat: x.location.latitude,
            lng: x.location.longitude
          })
        })
        this.$refs.gmap.fitBounds(bounds)
      },
      openWindowInfo (p) {
        this.program = p
        this.programLotCount = null
        let query = Object.assign({}, this.filters)
        this.getLotsCount(query, p.program)
        // this.center = {lat: p.location.latitude, lng: p.location.longitude}
        this.windowInfoPos = {lat: p.location.latitude, lng: p.location.longitude}
        this.windowInfoOpened = true
      },
      submit () {
        this.smallLoading = true
        if (Array.isArray(this.filters.lot_type)) {
          const tmp = []
          this.filters.lot_type.forEach(t => {
            tmp.push(t)
            tmp.push(t + '_duplex')
            tmp.push(t + '_bis')
          })
          this.filters.lot_type = tmp
        }
        let initPrograms = true
        this.getLotsCount(this.filters)
        this.getPrograms(this.filters, initPrograms)
      },
      getPrograms (query, initPrograms = false, page = 1) {
        let filters = Object.assign(query, {per_page: 50, page})
        this.$api.programService.getStock(filters).then(r => {
          this.loading = false
          if (initPrograms) this.programs = []
          let programsPk = this.programs.map(x => x.pk)
          let newData = r.data.items.filter(x => {
            return !programsPk.includes(x.pk)
          })
          this.programs = this.programs.concat(newData)
          if (r.data.page < r.data.pages) {
            this.smallLoading = true
            page++
            initPrograms = false
            this.getPrograms(query, initPrograms, page)
          } else {
            this.smallLoading = false
          }
          if (r.data.items.length > 0) {
            // this.fitBounds()
          } else {
            this.zoomOnFrance()
          }
        }).catch(() => {
          this.loading = false
        })
      },
      getAddressData (value) {
        let newAddress = {}
        value.address_components.forEach((el, idx) => {
          newAddress[el.types[0]] = el.long_name
        })
        this.$set(this.filters.address, 'city', newAddress.locality)
        this.submit()
      },
      getLotsCount (query, program = null) {
        let filters = Object.assign(query, {per_page: 1, page: 1})
        if (program) {
          filters.program = program
        }
        filters.status = ['available', 'optioned']
        this.$api.lotService.get(filters).then(r => {
          if (program) {
            this.programLotCount = r.data.total
          } else {
            this.lotCount = r.data.total
          }
        })
      }
    },
    created () {
      this.submit()
    }
  }
</script>

<style scoped>
  .card-content {
    padding: .75rem;
  }

  .map-fixed .map-info {
    width: 220px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/DashboardSeller.vue